interface WebsiteResource {
  title: string;
  description: string;
  url: string;
}

const resources: WebsiteResource[] = [
  {
    title: "YaoCube 261kWh 中文参数表",
    description: "工商业液冷户外一体柜 · PDF",
    url: "https://jinkosolarcdn.shwebspace.com/uploads/261kWh.pdf"
  },
  {
    title: "YaoGrid 5.01MWh 中文参数表",
    description: "电网级液冷储能系统 · PDF",
    url: "https://jinkosolarcdn.shwebspace.com/uploads/5.01MWh.pdf"
  },
  {
    title: "YaoGrid 6.25MWh 中文参数表",
    description: "20尺液冷储能系统 · PDF",
    url: "https://jinkosolarcdn.shwebspace.com/uploads/6.25MWh.pdf"
  }
];

export function toCustomerFacingText(content: string): string {
  return content
    .replace(/在\s*Salesforce\s*中查看记录/gi, "查看处理详情")
    .replace(/Salesforce\s*(?:未完成|未返回|返回|当前)?/gi, "")
    .replace(/\bCRM\b/gi, "客户服务")
    .replace(/\bLead\b/g, "项目咨询")
    .replace(/\bCase\b/g, "服务申请")
    .replace(/\b(?:SOQL|API)\b/gi, "")
    .replace(/\b(?:00Q|500)[A-Za-z0-9]{12,15}\b/g, "已生成")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\s+([，。；：])/g, "$1")
    .trim();
}

export function toCustomerFacingError(content: string): string {
  const safe = toCustomerFacingText(content);
  if (/(?:验证码|邮箱|附件|文件|录音|语音|麦克风|浏览器|网络|\d+MB|PDF|JPG|PNG|TXT|CSV|XLSX)/i.test(safe) &&
    !/(?:HTTP|权限|字段|对象|endpoint|token|secret|stack|database|postgres)/i.test(safe)) return safe;
  return "当前暂未能完成处理，请稍后重试；如果仍无法完成，请继续留言，我们会协助处理。";
}

export function WebsiteMessageContent({ content, onResourceOpen }: { content: string; onResourceOpen: (title: string) => void }) {
  const matched = resources.filter((resource) => content.includes(resource.url));
  const text = toCustomerFacingText(matched.reduce((current, resource) => current.replaceAll(resource.url, ""), content))
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .join("\n");
  return (
    <>
      <p>{text}</p>
      {matched.length ? <div className="website-resource-list" aria-label="相关产品资料">
        {matched.map((resource) => <a
          className="website-resource-card"
          href={resource.url}
          target="_blank"
          rel="noopener noreferrer"
          key={resource.url}
          onClick={() => onResourceOpen(resource.title)}
        >
          <span className="website-resource-card__icon" aria-hidden="true">PDF</span>
          <span><strong>{resource.title}</strong><small>{resource.description}</small></span>
          <span aria-hidden="true">↗</span>
        </a>)}
      </div> : null}
    </>
  );
}
